import { NextPage } from 'next'

import HomePageLayout from 'components/ui/Layouts/HomePageLayout'
import { MetaTags } from 'components/shared'
import { GlowHeading, Link } from 'components/ui'
import { FAQs, TERMS_AND_CONDITIONS } from 'routes/external'

import styles from '../styles/pages/Fan-promise.module.scss'

const FanPromise: NextPage = () => (
  <>
    <MetaTags title="Fan Promise" />
    <HomePageLayout>
      <div className={styles['fan-promise']}>
        <div className={styles.section}>
          <GlowHeading Tag="h2" size="h1" color="g-green-darker">
            Granted Fan Promise
          </GlowHeading>
          Granted aims to treat every fan like a VIP. We are a small but mighty team of dedicated,
          real people that are here for you along the way. At Granted, we ensure 100% valid tickets
          from our trusted network or a full refund. If you’re still curious to find out more, here
          is what you can expect when you buy tickets from Granted:
          <ul>
            <li>
              Granted Support is available before, during, and after the event. (very nice humans,
              no robots)
            </li>
            <li>Your order is safe & secure / privacy is of utmost importance.</li>
            <li>You will get your tickets in time for the event.</li>
            <li>Your tickets will be valid for entry.</li>
            <li>Your tickets will match those that you ordered.</li>
            <li>
              In the rare event that your tickets do not match your order, we will make it right and
              find you comparable or even better quality tickets or offer you a full refund.
            </li>
            <li>If the event is rescheduled, your tickets will be valid for the new date.</li>
            <li>If the event is canceled, you will receive a full refund.</li>
            <li>
              If you&apos;re the winning bidder of an Auction, you will receive exclusive access to
              the described experience, or we will find you a comparable or even better experience
              or offer you a full refund.
            </li>
            <li>
              You can find our full Terms & Conditions{' '}
              <Link
                href={TERMS_AND_CONDITIONS}
                target="_blank"
                color="green"
                rel="noopener noreferrer"
              >
                here
              </Link>
            </li>
          </ul>
        </div>

        <div className={styles.section}>
          <h3>Do you guarantee the authenticity of my tickets?</h3>
          <div>
            Yes, every ticket sold on Granted is guaranteed for your entry into the event. We source
            our tickets from a trusted and vetted national network of authorized ticket brokers and
            you will receive the tickets prior to the event. The tickets that you purchase will
            match your order or we will work to locate comparable or better tickets or we will offer
            you a full refund.
          </div>
          <div>
            In regards to VIP Packages, such as VIP Meet & Greets and Auctions, we work directly
            with talent, venues, and promoters producing the event to provide exclusive access that
            is only available through Granted.
          </div>
          <div>
            We are fans just like you and know how important it is that your experience is seamless
            and Granted Support is available before, during, and after each event. It&apos;s time to
            get your access Granted!
          </div>
        </div>
        <div className={styles.section}>
          <h3>Is my order through Granted protected?</h3>
          We take protecting your personal information very seriously and use established industry
          standards for security and privacy to ensure all transactions through Granted are secure
          and safe.
        </div>
        <div className={styles.section}>
          <h3>Can I trust the tickets sold on Granted?</h3>
          <div>
            You know it! We work directly with licensed, authorized, and professional ticket
            resellers that guarantee the authenticity of their tickets. You can rest assured that
            every ticket purchased through us will grant you access to the event. Any exclusive VIP
            Package or Auction is coordinated directly with the talent, venues, and promoters
            producing the event to ensure a seamless experience.
          </div>
          <div>
            Keep in mind that Granted Support is available to answer any questions you have. You can
            trust us to do everything that we can to ensure that your experience is incredible. If
            for any reason the tickets or VIP experience is not as described, we will work to locate
            a comparable or better experience or we will offer you a full refund. Now that&apos;s
            peace-of-mind!
          </div>
        </div>
        <div className={styles['contact-section']}>
          Check out our{' '}
          <Link href={FAQs} color="green" target="_blank" rel="noopener noreferrer">
            FAQs
          </Link>{' '}
          for more information. Still have some questions for us? Go ahead and email us at{' '}
          <Link href="mailto:support@granted.co" color="green">
            support@granted.co
          </Link>
          . We love feedback and look forward to hearing from you!
        </div>
      </div>
    </HomePageLayout>
  </>
)

export default FanPromise
